import type { ChatMessageQuery } from '@winging/util/type/chat.type';
import {
  ChatRoomCreatedBy,
  ChatRoomType,
} from '@winging/util/type/chatroom.type';
import {
  createBuilderChatroom,
  getBuilderChatMessages,
  sendQueryBuilderMessage,
  sendStaticBuilderChatMessage,
} from '@/features/demo/api/builderCreator.chatMessage.service';
import { ChatService } from '@/shared/types/chatService.type';

export function makeDemoService(userId: string): ChatService {
  return {
    async createChatroom(_agentId) {
      const res = await createBuilderChatroom(userId);
      return {
        _id: res._id,
        chatroom_type: ChatRoomType.AI,
        user_id: userId,
        created_by: ChatRoomCreatedBy.Customer,
      };
    },
    async getNewMessages(chatroomId, lastId, signal) {
      return getBuilderChatMessages(chatroomId, userId, lastId, signal);
    },
    async sendStaticMessage(message, chatroomId, _agentId) {
      await sendStaticBuilderChatMessage(message, chatroomId, userId);
    },
    async sendQueryMessage(message, chatroomId, _agentId) {
      await sendQueryBuilderMessage(
        message as ChatMessageQuery,
        chatroomId,
        userId
      );
    },
    async updateChatRoomType() {
      // Builder API does not support chatroom type updates
    },
  };
}
